import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const provider = params.get('provider') || 'twitch';
    const error = params.get('error');
    const desc = params.get('error_description');
    // Forward to integrations with a message
    const target = new URL('/integrations', window.location.origin);
    if (error) {
      target.searchParams.set('oauth_error', error);
      if (desc) target.searchParams.set('oauth_error_description', desc);
      target.searchParams.set('provider', provider);
    } else {
      target.searchParams.set('provider', provider);
      target.searchParams.set('status', 'success');
    }
    nav(target.pathname + target.search, { replace: true });
  }, [loc.search, nav]);

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginTop: 0 }}>Leite zurück …</h2>
      <p>Bitte warten.</p>
    </div>
  );
}
